export {
  type GetGraphemePrevalenceOptions,
  type GraphemePrevalence,
  type GraphemePrevalenceResult,
  getGraphemePrevalence,
} from "#grapheme-prevalence";
